import React from 'react';

/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';
import CardsSlider from '../../components/CardsSlider';
import Chip from '@material-ui/core/Chip';
// components
// import AsyncSearch from './AsyncSearch';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import links from 'utils/links';
import { getQueryValue } from 'utils/';

const styles = theme => ({
  selectedChip: {
    backgroundColor: theme.palette.primary.main,
    border: '1px solid grey',
    margin: '5px 10px 0px 0px',
    '&:hover': {
      '@media (hover: none)': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  searchContainer: {
    padding: '20px',
  },
  searchBar: {
    width: '100%',
  },
  categoryContainer: {
    padding: '10px 20px 10px 20px',
    backgroundColor: theme.palette.others.bg1,
  },
  chip: {
    border: '1px solid grey',
    margin: '5px 10px 0px 0px',
  },
});

const CountContainer = ({
  classes,
  displayResults,
  results,
  category,
  onCatChange,
  keyword,
}) => {
  if (results.length <= 0) {
    return (
      <div className={classes.categoryContainer}>
        <Typography variant="body2">ARTICLES RELATED TO "{keyword}"</Typography>
        <Chip
          label="No Match Found!"
          onClick={() => {}}
          className={classes.chip}
        />
      </div>
    );
  } else {
    var stories = [],
      eateries = [],
      listicles = [],
      experiences = [];
    results.forEach(result => {
      switch (result.resourceType) {
        case 'LISTICLE':
          listicles.push(result);
          return 0;
        case 'EATERY':
          eateries.push(result);
          return 0;
        case 'STORY':
          stories.push(result);
          return 0;
        case 'EXPERIENCE':
          experiences.push(result);
          return 0;
        default:
          return 0;
      }
    });
    return (
      <div className={classes.categoryContainer}>
        <Typography variant="body2">ARTICLES</Typography>
        {results.length > 0 ? (
          <Chip
            label={'All ' + results.length}
            onClick={() => onCatChange('ALL')}
            className={category === 'ALL' ? classes.selectedChip : classes.chip}
          />
        ) : (
          ''
        )}
        {eateries.length > 0 ? (
          <Chip
            label={'Eateries ' + eateries.length}
            onClick={() => onCatChange('EATERY')}
            className={
              category === 'EATERY' ? classes.selectedChip : classes.chip
            }
          />
        ) : (
          ''
        )}
        {stories.length > 0 ? (
          <Chip
            label={'Stories ' + stories.length}
            onClick={e => {
              e.preventDefault();
              onCatChange('STORY');
            }}
            className={
              category === 'STORY' ? classes.selectedChip : classes.chip
            }
          />
        ) : (
          ''
        )}
        {experiences.length > 0 ? (
          <Chip
            label={'Experiences ' + experiences.length}
            onClick={() => onCatChange('EXPERIENCE')}
            className={
              category === 'EXPERIENCE' ? classes.selectedChip : classes.chip
            }
          />
        ) : (
          ''
        )}
        {listicles.length > 0 ? (
          <Chip
            label={'Listicles ' + listicles.length}
            onClick={() => onCatChange('LISTICLE')}
            className={
              category === 'LISTICLE' ? classes.selectedChip : classes.chip
            }
          />
        ) : (
          ''
        )}
      </div>
    );
  }
};

class Search extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    category: 'EATERY',
    displayResults: this.props.results,
    searchKey: getQueryValue("key"),
  };
  componentDidMount() {
    let keyword = getQueryValue("key");
    if (keyword.length > 2) {
      this.props.dispatch(actions.getData(keyword));
    }
  }
  componentDidUpdate(prevProps) {
    let { history } = this.props;
    let newKeyWord = getQueryValue("key");
    let oldKeyWord = getQueryValue("key",prevProps.location.search);
    if (newKeyWord !== oldKeyWord) {
      if (newKeyWord.length > 2) {
        this.setState({ searchKey: newKeyWord });
        history.push(links.searchLink(newKeyWord));
        this.props.dispatch(actions.getData(newKeyWord));
      }
    }
    if (this.props.results !== prevProps.results) {
      this.setState({
        displayResults: this.props.results,
      });
    }
  }
  handleCatChange(category) {
    let newResults = [];
    if (category === 'ALL') newResults = this.props.results;
    else {
      this.props.results.forEach(result => {
        if (result.resourceType === category) {
          newResults.push(result);
        }
      });
    }
    this.setState({
      category: category,
      displayResults: newResults,
    });
  }
  handleChange(e) {
    this.setState({ searchKey: e.target.value });
  }
  handleKeyPress(e) {
    let { history } = this.props;
    if (e.charCode === 13) {
      history.push(links.searchLink(e.target.value));
    } else if (e.keyCode === 13) {
      history.push(links.searchLink(e.target.value));
    }
  }
  render() {
    const { classes, loading, results } = this.props;
    const { keyword } = this.props.match.params;
    return (
      <div>
        <div className={classes.searchContainer}>
          <TextField
            id="outlined-search"
            label="Search Article"
            type="search"
            margin="normal"
            variant="outlined"
            className={classes.searchBar}
            value={this.state.searchKey}
            onKeyPress={this.handleKeyPress}
            onChange={this.handleChange}
          />
        </div>
        <CountContainer
          onCatChange={this.handleCatChange}
          category={this.state.category}
          keyword={keyword}
          classes={classes}
          results={results}
        />
        <br />
        {loading ? (
          <Loader />
        ) : (
          <CardsSlider noshuffle={true} noslider={true} cards={this.state.displayResults} />
        )}
        <br />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(Search));
